<template>
  <gj-modal
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      :loading="modalLoading"
      @cancel="cancel"
      @confirm="confirm"
      @close="$emit('modalCancel')"
  >
    <template #header>录入物流费用</template>
    <template #content>
      <div>
        <el-form :model="form" ref="form">
           <div style="display: flex;align-items: center;justify-content: space-between;">
             <gj-area-title>费用信息</gj-area-title>
             <gj-button @click="previewResult" type="primary" style="margin-bottom: 12px">预览分摊结果</gj-button>
           </div>
          <div>
            <gj-table
                ref="gjTable"
                :index="false"
                name="costInfoTable"
                :data="form.items"
                :height="200"
                :highlight-hover-row="false"
                :adapt-height="false"
                :show-overflow="false"
                :columns="costColumns">
              <template v-slot:logisticsCode="{row,index}">
                <el-form-item  class="gj-table-item">
                  <gj-logistics-select
                      placeholder="请选择物流商"
                      v-model="form.items[index].logisticsCode"
                      width="150px"
                  ></gj-logistics-select>
                </el-form-item>
              </template>
              <template v-slot:feeTypeName="{row, index}">
                <el-form-item  class="gj-table-item"
                    :prop="`items.${index}.feeTypeName`"
                    :rules="[
                      $gjRequired('请选择费用类型')
                    ]">
                  <gj-select
                      :clearable="false"
                      :options="feeTypeNameOption"
                      v-model="form.items[index].feeTypeName"
                      width="120px"
                  ></gj-select>
                </el-form-item>
              </template>
              <template v-slot:currency="{row, index}">
                <el-form-item
                    class="gj-table-item"
                    :prop="`items.${index}.currency`"
                    :rules="[{ required: true, message: '请选择币种' }]"
                >
                  <gj-select
                      :clearable="false"
                      :options="currencyOption"
                      v-model="form.items[index].currency"
                      @input="changeCurrency"
                  ></gj-select>
                </el-form-item>
              </template>
              <template v-slot:transportType="{row, index}">
                <el-form-item
                    class="gj-table-item"
                    :prop="`items.${index}.transportType`"
                    :rules="[{ required: true, message: '请选择分摊方式' }]"
                >
                  <gj-select
                      :clearable="false"
                      :options="[
                        {id: 'weight', text: '按实重(KG)'},
                        {id: 'volume', text: '按体积(CBM)'},
                        {id: 'volumeWeight', text: '按体积重(KG)'},
                        {id: 'quantity', text: '按数量'},
                        {id: 'applyPrice', text: '按申报单价'},
                        {id: 'unAttend', text: '不参与计算'},
                      ]"
                      placeholder="分摊方式"
                      v-model="form.items[index].transportType"
                      width="140px"
                  ></gj-select>
                </el-form-item>
              </template>
              <template v-slot:fee="{row, index}">
                <el-form-item
                    class="gj-table-item"
                    :prop="`items.${index}.fee`"
                    :rules="[{ required: true, message: '请输入费用', trigger: ['change','blur'] },$gjReRule(RE.num(2), '最多两位小数的正数')  ]"
                >
                  <gj-input
                      placeholder="请输入费用"
                      v-model="form.items[index].fee"
                      width="120px"></gj-input>
                </el-form-item>
              </template>
              <template v-slot:memo="{row, index}">
                <el-form-item  class="gj-table-item">
                  <gj-input width="100%"
                      placeholder="请输入备注"
                      v-model="form.items[index].memo"></gj-input>
                </el-form-item>
              </template>
              <template v-slot:op="{index}">
                <gj-button type="text" @click="addItem(index)">
                  <i class="el-icon-circle-plus-outline" style="font-size: 20px;color: #333333;"></i>
                </gj-button>
                <gj-button type="text" @click="deleteItem(index)" v-show="form.items.length > 1">
                  <i class="el-icon-remove-outline" style="font-size: 20px;color: #333333;"></i>
                </gj-button>
              </template>
            </gj-table>
          </div>

        </el-form>
        <template v-if="showPreview">
          <el-form
              :model="form2"
              ref="form2"
          >
            <gj-area-title style="margin-top: 20px">分摊结果</gj-area-title>
            <gj-table
                :adapt-height="false"
                :columns="tableColumns"
                :show-overflow="false"
                :data="form2.items"
                :height="400"
                :index="false"
            >
              <template v-slot:productInfo="{row}">
                <div>{{row.productName}}</div>
                <div>{{row.sku}}</div>
                <div>{{row.categoryName	}}</div>
              </template>
              <template v-slot:msku="{row}">
                <div>{{row.msku}}</div>
                <div>{{row.fnsku}}</div>
                <div>{{row.asin}}</div>
              </template>
              <template v-for="(col, rowIndex) in dynamicCol" v-slot:[col.key]="{index}">
                <el-form-item
                    :prop="`items.${index}.${col.key}`"
                    :key="rowIndex"
                    class="gj-table-item not-form-item-mgb"
                    :rules="[
                      $gjRequired('请输入单价'),
                      $gjReRule(RE.num(4), '请输入最多四位小数的正数'),
                    ]"
                >
                  <gj-input v-model="form2.items[index][col.key]">
                    <template #prefix>{{col.currencySymbol}}</template>
                  </gj-input>
                </el-form-item>
              </template>
              <template v-for="(col, index) in dynamicTotalCol" v-slot:[col.totalKey]="{row}">
                <div :key="index">
                  {{col.currencySymbol}}{{calcFeeTotal(row, col.key)}}
                </div>
              </template>
            </gj-table>
          </el-form>
        </template>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn, responseMixin} from "@/minxins";
  import {currencysOption} from "@/utils/options";
  import {getDictionaryCombobox} from "@/api/common";
  import {
    getInputLogisticsFee,
    getPreviewShareResult,
    saveShipNoteLogisticsFeeShare
  } from "@/api/logistics";
  import {mapGetters} from "vuex";
  import {isMeaningful, isMeaningless} from "@/utils/common";

  export default {
    name: "app-shipment-bill-logistics-fee",
    mixins: [modalMixIn, formRuleMixin, responseMixin],
    props: {
      productItems: null,
      code: null,
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    created() {
      getDictionaryCombobox('LOGISTICS_FEE_TYPE')
        .then((data) => {
          this.feeTypeNameOption = data;
        });
      if (isMeaningful(this.code)) {
        this.modalLoading = true;
        getInputLogisticsFee(this.code)
          .then((data) => {
            if (isMeaningful(data)) {
              this.showPreview = true;
              if(data.logisticsFeeList.length > 0){
                this.form.items = data.logisticsFeeList;
              }else{
                this.addItem(0);
              }
              this.buildCol(data.logisticsFeeShareVOList);
            }
          }).complete(() => this.modalLoading = false)
      }
    },
    data() {
      return {
        tableLoading: false,
        modalLoading: false,
        form: {
          items: [],
        },
        currencyOption: currencysOption.map(v => ({id: v.id, text: v.id})),
        showPreview: false,
        form2: {
          items: []
        },
        costColumns:[
          {id: 'logisticsCode', header: '物流商', field: 'slot:logisticsCode', minWidth: '100px'},
          {id: 'feeTypeName', header: '费用类型', field: 'slot:feeTypeName', minWidth: '100px'},
          {id: 'currency', header: '币种', field: 'slot:currency', minWidth: '100px'},
          {id: 'transportType', header: '分摊方式', field: 'slot:transportType', minWidth: '100px'},
          {id: 'fee', header: '费用', field: 'slot:fee', minWidth: '100px'},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '150px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '100px'},
        ],
        columns: [
          {id: 'warehouseName', header: '目的仓', field: 'warehouseName', width: '70px'},
          {id: 'warehouseCode', header: '配送地址', field: 'centerId', minWidth: '80px'},
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', minWidth: '50px'},
          {id: 'marketId', header: '国家/店铺', field: 'option:marketId', minWidth: '120px', options: () => this.marketOption},
          {id: 'productInfo', header: '产品名称/SKU/产品类型-品类', field: 'slot:productInfo', minWidth: '180px'},
          {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '130px'},
          {id: 'singleWeight', header: '单品实重(g)', field: 'singleWeight', minWidth: '70px'},
          {id: 'volume', header: '单品体积(CBM)', field: 'volume', minWidth: '70px'},
          {id: 'singleVolumeWeight', header: '单品体积重(KG)', field: 'singleVolumeWeight', minWidth: '70px'},
          {id: 'singleApplyPrice', header: '单品申报单价', field: 'singleApplyPrice', minWidth: '60px'},
          {id: 'quantity', header: '发货量', field: 'quantity', minWidth: '60px'},
        ],
        tableColumns: [],
        dynamicCol: [],
        dynamicTotalCol: [],
        feeTypeNameOption: [],
      }
    },
    methods: {
      addItem(index) {
        let item = {
          logisticsCode: null,
          feeTypeName: null,
          currency: null,
          transportType: null,
          fee: null,
          memo: null,
        }
        this.form.items.splice(index + 1,0,item);
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
      },
      previewResult() {
        if (this.$gjFormValidate()) {
          this.showPreview = true;
          this.tableLoading = true;
          getPreviewShareResult({
            feeList: this.form.items,
            shipNoteItemList: this.productItems,
            shipNoteCode: this.code
          }).then((data) => {
            this.buildCol(data);
          }).complete(() => this.tableLoading = false)
        }
      },
      buildCol(data) {
        const cols = [];
        if (data.length !== 0) {
          this.dynamicCol = data[0].logisticsFeeItemList;
          this.dynamicTotalCol = data[0].logisticsFeeItemList.map(v => {
            return {
              key: v.key,
              totalKey: v.key + 'Total',
              currencySymbol: v.currencySymbol,
            }
          });
          const time = new Date().getTime();
          for (let i = 0; i< data.length; i++) {
            data[i].logisticsFeeItemList.forEach(v => {
              data[i][v.key] = v.fee;
              if (i === 0) {
                cols.push({id: v.key + time, header: v.feeTypeName + '分摊单价', field: `slot:${v.key}`, minWidth: '100px'});
                cols.push({id: v.key + 'Total' + time, header: v.feeTypeName + '总价', field: `slot:${v.key}Total`, minWidth: '80px', align: 'right'});
              }
            })
          }
        } else {
          this.dynamicCol = [];
        }
        this.form2.items = data;
        this.tableColumns = this.columns.concat(cols);
      },
      calcFeeTotal(row, key) {
        if (isMeaningless(row[key]) || isMeaningless(row.quantity) || isNaN(row[key]) || isNaN(row.quantity)) {
          return 0;
        }
        return (Number(row[key]) * Number(row.quantity)).toFixed(4);
      },
      confirm() {
        if (this.validateForm2()) {
          this.form2.items.forEach(v => {
            for (let key in v) {
              if (this.dynamicCol.some(val => val.key === key)) {
                for (let i = 0; i < v.logisticsFeeItemList.length; i++) {
                  if (v.logisticsFeeItemList[i].key === key) {
                    v.logisticsFeeItemList[i].fee = v[key];
                  }
                }
              }
            }
            v['feeItemSaveDTOList'] = (v.logisticsFeeItemList || []).map(val => {
              return {
                fee: val.fee,
                feeTypeName: val.feeTypeName,
                currency: val.currency
              }
            })
          });
          this.confirmLoading = true;
          saveShipNoteLogisticsFeeShare({
            feeList: this.form.items,
            feeShareList: this.form2.items,
            shipNoteCode: this.code
          })
            .then((res) => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('操作成功');
                this.$emit('modalCancel');
                this.$emit('inputSuccess');
                this.$gjDestroy();
              });
            }).complete(() => this.confirmLoading = false)
        }
      },
      cancel() {
        this.$gjDestroy();
        this.$emit('modalCancel');
      },
      validateForm2() {
        let formValid = false;
        this.$refs.form2.validate((valid) => {
          formValid = valid;
        });
        return formValid;
      },
      changeCurrency(currency) {
        this.form.items.forEach(v => v.currency = currency);
      }
    }
  }
</script>

<style scoped>
  /deep/ .gj-modal--full .el-dialog {
    width: 1366px !important;
  }
  /deep/ .gj-table--default td:not(.vxe-footer--column){
     height: 56px !important;
  }
</style>
